import { NORMALIZE_GUID_REGEX } from 'src/constants';

export const formatIdWithBraces = (id: string): string => id.replace(NORMALIZE_GUID_REGEX, '{$1-$2-$3-$4-$5}').toUpperCase();

export const formatStringIDsToArray = (value: string): string[] => value.split('|').map((s) => formatIdWithBraces(s));

export const formatArrayIDsToString = (ids: string[]): string => ids.join('|');
